import 'hammerjs';
import Hammer from 'hammerjs';
import { ToastrModule } from 'ngx-toastr';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireModule } from '@angular/fire/compat';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from './shared/shared.module';
import { MyHttpInterceptor } from './shared/http.interceptor';
import { environment } from '../environments/environment';
import { MessagingService } from './services/messaging.service';
import { CustomValidators } from './services/custom-validators.service';
import { HeaderMobileService } from './services/header-mobile.service';
import { BottomMobileService } from './services/bottom-mobile.service';
import { CanDeactivateGuard } from './services/guards/keepSave.guard';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ApplicationConfig, importProvidersFrom, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@shared/environment';
import { GoogleMapsModule } from '@angular/google-maps';
import { provideRouter, withRouterConfig } from '@angular/router';
import { routerOptions, routes } from './app-routing.module';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
	override buildHammer(element: HTMLElement) {
		const mc = new Hammer(element, {
			touchAction: 'pan-y',
		});

		return mc;
	}
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes, withRouterConfig(routerOptions)),
		importProvidersFrom(
			BrowserModule,
			BrowserAnimationsModule,
			HttpClientModule,
			FlexLayoutModule,
			FontAwesomeModule,
			MatAutocompleteModule,
			SharedModule.forRoot(),
			ToastrModule.forRoot({
				positionClass: 'toast-bottom-right',
				closeButton: true,
				timeOut: 8000,
				preventDuplicates: true,
			}),
			InfiniteScrollModule,
			AngularFireDatabaseModule,
			AngularFireAuthModule,
			AngularFireMessagingModule,
			AngularFireModule.initializeApp(environment.firebase),
			NgxPermissionsModule.forRoot(),
			GoogleMapsModule
		),
		MessagingService,
		CustomValidators,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MyHttpInterceptor,
			multi: true,
		},
		HeaderMobileService,
		BottomMobileService,
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: MyHammerConfig,
		},
		CanDeactivateGuard,
		{
			provide: ENVIRONMENT,
			useValue: environment,
		},
	],
};
